import styled from '@emotion/styled';
import RecommendationCard from '@travelnest/merlin.recommendation-card';
import { Spacer } from '@travelnest/merlin.spacer';
import React from 'react';
import { IPropertyScoreAttributeWithIncrease } from './property-score-helpers';
import { formatDateTimeString } from './property-score-helpers';
import { contentLookup } from './recommendationContentLookup';

const RecommendationListWrapper = styled.div`
	flex: 1;
	&:nth-of-type(odd) {
		margin-right: 10px;
	}
	&:nth-of-type(even) {
		margin-left: 10px;
	}
`;

const MobileWrapper = styled.div`
	display: block;
	@media only screen and (min-width: 768px) {
		display: none;
	}
`;

const DesktopWrapper = styled.div`
	display: none;
	@media only screen and (min-width: 768px) {
		display: flex;
		max-width: 1050px; // reco card width * 2 plus margin
	}
`;
interface IRecommendationList {
	recommendations: IPropertyScoreAttributeWithIncrease[];
	customerId: string;
	snoozeRecommendation: (ownerId: string, propertyId: number, attributeName: string) => void;
}

export const RecommendationList = ({ recommendations, customerId, snoozeRecommendation }: IRecommendationList) => {
	const lhsRecommendations: Array<IPropertyScoreAttributeWithIncrease & { priority: number }> = [];
	const rhsRecommendations: Array<IPropertyScoreAttributeWithIncrease & { priority: number }> = [];
	const implementedRecommendations = recommendations.filter((r) => contentLookup.hasOwnProperty(r.attribute_name));
	implementedRecommendations.forEach((rec, idx) => {
		if ((idx + 1) % 2 === 0) {
			rhsRecommendations.push({ ...rec, priority: idx + 1 });
		} else {
			lhsRecommendations.push({ ...rec, priority: idx + 1 });
		}
	});
	return (
		<>
			<MobileWrapper>
				{implementedRecommendations.map((r, i) => {
					const { status, action, buttonLink, buttonText } = contentLookup[r.attribute_name];
					return (
						<React.Fragment key={`${r.property_id}-${r.attribute_name}`}>
							<RecommendationCard
								key={`${r.property_id}-${r.attribute_name}`}
								status={`${i + 1}. ${status(r.points)}`}
								action={action(r.points)}
								buttonText={buttonText}
								buttonLink={buttonLink(r.property_id)}
								points={r.potentialScoreIncrease}
								updatedAt={r.updated_at ? formatDateTimeString(r.updated_at) : ''}
								isSnoozed={!!r.snoozed_until}
								isComplete={r.potentialScoreIncrease === 0}
								onCrossClick={() => snoozeRecommendation(customerId, r.property_id, r.attribute_name)}
							/>
							<Spacer />
						</React.Fragment>
					);
				})}
			</MobileWrapper>
			<DesktopWrapper>
				<RecommendationListWrapper>
					{lhsRecommendations.map((r, i) => {
						const { status, action, buttonLink, buttonText } = contentLookup[r.attribute_name];
						return (
							<React.Fragment key={`${r.property_id}-${r.attribute_name}`}>
								<RecommendationCard
									key={`${r.property_id}-${r.attribute_name}`}
									status={`${r.priority}. ${status(r.points)}`}
									action={action(r.points)}
									buttonText={buttonText}
									buttonLink={buttonLink(r.property_id)}
									points={r.potentialScoreIncrease}
									updatedAt={r.updated_at ? formatDateTimeString(r.updated_at) : ''}
									isSnoozed={!!r.snoozed_until}
									isComplete={r.potentialScoreIncrease === 0}
									onCrossClick={() => snoozeRecommendation(customerId, r.property_id, r.attribute_name)}
								/>
								<Spacer />
							</React.Fragment>
						);
					})}
				</RecommendationListWrapper>
				<RecommendationListWrapper>
					{rhsRecommendations.map((r, i) => {
						const { status, action, buttonLink, buttonText } = contentLookup[r.attribute_name];
						return (
							<React.Fragment key={`${r.property_id}-${r.attribute_name}`}>
								<RecommendationCard
									key={`${r.property_id}-${r.attribute_name}`}
									status={`${r.priority}. ${status(r.points)}`}
									action={action(r.points)}
									buttonText={buttonText}
									buttonLink={buttonLink(r.property_id)}
									points={r.potentialScoreIncrease}
									updatedAt={r.updated_at ? formatDateTimeString(r.updated_at) : ''}
									isSnoozed={!!r.snoozed_until}
									isComplete={r.potentialScoreIncrease === 0}
									onCrossClick={() => snoozeRecommendation(customerId, r.property_id, r.attribute_name)}
								/>
								<Spacer />
							</React.Fragment>
						);
					})}
				</RecommendationListWrapper>

			</DesktopWrapper>
		</>
	);
};
